import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  message,
  Upload,
  Radio,
  Result,
  Modal,
} from "antd";
import {
  PlusOutlined,
  MinusCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { firebaseAPI } from "../firebaseConfig";
import firebaseConfig from "../firebaseConfig";
import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { cookieStorageManager } from "@chakra-ui/react";
import axiosInstance from "../utils/axiosInstance";

const { Option } = Select;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

const uploadFileToFirebase = async (file) => {
  try {
    const uid = uuidv4();
    const uniqueFileName = `${uid}-${file.name}`;
    const storageRef = ref(storage, `ur-uploads/${uniqueFileName}`);

    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    return url;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

const FormBuilderPage = () => {
  const { formName, programName } = useParams();
  const [formDetails, setFormDetails] = useState({
    name: formName,
    startDate: "",
    deadline: "",
    timer: 0,
    questions: [],
  });
  const [formExist, setFormExist] = useState(true);
  const [formKey, setFormKey] = useState(0);
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  const location = useLocation();

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchForm = async () => {
      try {
        let token = Cookies.get("token") || "";
        if (formName) {
          const response = await axiosInstance.get(
            `${firebaseAPI}/forms/${formName}/${programName}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          //console.log("Heyy");
          if (response.status === 200) {
            //console.log(response.data);
            message.success("Form details fetched successfully!", 2);
            setFormDetails(response.data);
            ////console.log(formatDate(response.data.startDate));
            setIsFormDisabled(response.data.roundWithoutForm);
          } else {
            message.error(response.data.message, 4);
          }
        }
      } catch (error) {
        setFormExist(false);
        console.error("Error fetching form:", error);
      }
    };

    fetchForm();
  }, [formName]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDetails({ ...formDetails, [name]: value });
  };

  const handleQuestionAdd = (index) => {
    setFormDetails((prevFormDetails) => {
      const newQuestions = [
        ...prevFormDetails.questions.slice(0, index + 1),
        {
          questionContent: "",
          questionImage: "",
          questionType: "Text",
          questionChoices: [],
          questionCorrectAnswer: "",
        },
        ...prevFormDetails.questions.slice(index + 1),
      ];

      return {
        ...prevFormDetails,
        questions: newQuestions,
      };
    });
    setFormKey((prevKey) => prevKey + 1);
  };

  const handleQuestionRemove = (index) => {
    setFormDetails((prevFormDetails) => {
      const updatedQuestions = prevFormDetails.questions.filter(
        (_, i) => i !== index
      );
      return {
        ...prevFormDetails,
        questions: updatedQuestions,
      };
    });
    setFormKey((prevKey) => prevKey + 1);
  };

  const handleQuestionChange = (index, fieldName, value) => {
    const updatedQuestions = [...formDetails.questions];
    updatedQuestions[index][fieldName] = value;
    setFormDetails({ ...formDetails, questions: updatedQuestions });
  };

  const handleChoiceAdd = (qIndex) => {
    const updatedQuestions = [...formDetails.questions];
    if (Array.isArray(updatedQuestions[qIndex].questionChoices)) {
      updatedQuestions[qIndex].questionChoices.push({
        type: "text",
        value: "",
      });
    } else {
      updatedQuestions[qIndex].questionChoices = [{ type: "text", value: "" }];
    }
    setFormDetails({ ...formDetails, questions: updatedQuestions });
    setFormKey((prevKey) => prevKey + 1);
  };

  const handleChoiceRemove = (qIndex, cIndex) => {
    const updatedQuestions = [...formDetails.questions];
    updatedQuestions[qIndex].questionChoices.splice(cIndex, 1);
    setFormDetails({ ...formDetails, questions: updatedQuestions });
    setFormKey((prevKey) => prevKey + 1);
  };

  const handleChoiceChange = (qIndex, cIndex, field, value) => {
    const updatedQuestions = [...formDetails.questions];
    updatedQuestions[qIndex].questionChoices[cIndex][field] = value;
    setFormDetails({ ...formDetails, questions: updatedQuestions });
  };

  const handleFileUpload = async (file, qIndex, cIndex) => {
    try {
      const url = await uploadFileToFirebase(file);
      handleChoiceChange(qIndex, cIndex, "value", url);
    } catch (error) {
      message.error("Failed to upload file.");
    }
  };

  const handleCorrectAnswerChange = (qIndex, value) => {
    const updatedQuestions = [...formDetails.questions];
    updatedQuestions[qIndex].questionCorrectAnswer = value;
    setFormDetails({ ...formDetails, questions: updatedQuestions });
  };

  const handleQuestionImageUpload = async (file, qIndex) => {
    try {
      const url = await uploadFileToFirebase(file);
      handleQuestionChange(qIndex, "questionImage", url);
    } catch (error) {
      message.error("Failed to upload question image.");
    }
  };

  const handleMakeRoundWithoutFormForm = async () => {
    try {
      let token = Cookies.get("token") || "";
      if (formName) {
        const response = await axiosInstance.post(
          `${firebaseAPI}/forms/makeRoundWithoutForm`,
          { programName, roundName: formName },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          message.success("Form Disabled successfully!", 2);
        } else {
          message.error(response.data.message, 4);
        }
      }
    } catch (error) {
      setFormExist(false);
      console.error("Error disabling form:", error);
    }
  };

  const { confirm } = Modal;

  const showConfirm = () => {
    confirm({
      title: "Are you sure you want to disable the form?",
      content:
        "This action cannot be undone. All Participants qualified to this round will have a record in the Round Scores page and won't have to submit a form.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleMakeRoundWithoutFormForm();
      },
      onCancel() {
        //console.log("Cancel");
      },
    });
  };

  const handleFormSubmit = async () => {
    try {
      const updatedFormDetails = {
        ...formDetails,
        questions: formDetails.questions.map((question) => ({
          ...question,
          questionContent: question.questionImage
            ? `${question.questionContent}`
            : question.questionContent,
        })),
      };
      let token = Cookies.get("token") || "";
      await axiosInstance.post(
        `${firebaseAPI}/forms`,
        { ...updatedFormDetails, programName },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      message.success("Form submitted successfully!", 2);
    } catch (error) {
      console.error("Error creating/updating form:", error);
      message.error("Failed to submit the form.", 4);
    }
  };
  if (isFormDisabled) {
    return (
      <Result status="warning" title="This Round Form has been disabled" />
    );
  }
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "clip",
      }}
    >
      <h1 style={{ marginBottom: "16px" }}>
        {formExist ? "Edit Form" : "Create Form"}
      </h1>
      <Form
        key={formKey}
        labelAlign="left"
        style={{
          textAlign: "left",
          flex: "1 0 0",
          height: "1px",
          display: "flex",
          flexDirection: "column",
        }}
        labelCol={{ span: 3 }}
      >
        <Form.Item label="Form Name">
          <Input
            name="name"
            value={formName}
            onChange={handleInputChange}
            disabled
          />
        </Form.Item>
        <Form.Item label="Start Date">
          <Input
            type="date"
            name="startDate"
            value={formDetails ? formatDate(formDetails.startDate) : ""}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Deadline">
          <Input
            type="date"
            name="deadline"
            value={formDetails ? formatDate(formDetails.deadline) : ""}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Form Timer (in min)">
          <Input
            type="number"
            name="timer"
            value={formDetails ? parseInt(formDetails.timer) : "0"}
            onChange={handleInputChange}
          />
        </Form.Item>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "12px",
            margin: "12px 0",
            overflowY: "auto",
            border: "1px solid #bbb",
            height: "1px",
            flex: "1 0 0",
            padding: "8px",
            borderRadius: "4px",
          }}
        >
          {formDetails &&
            formDetails.questions &&
            formDetails.questions.map((question, qIndex) => (
              <div
                key={qIndex}
                style={{
                  border: "1px dashed #b8b8b8",
                  padding: "8px 12px",
                  borderRadius: "5px",
                }}
              >
                <div style={{ display: "flex", columnGap: "8px" }}>
                  <Form.Item
                    label={`Question ${qIndex + 1}`}
                    style={{ flex: "1 0 auto" }}
                  >
                    <Input.TextArea
                      defaultValue={question.questionContent}
                      onChange={(e) =>
                        handleQuestionChange(
                          qIndex,
                          "questionContent",
                          e.target.value
                        )
                      }
                      rows={1}
                    />
                  </Form.Item>
                  <Button
                    icon={<MinusCircleOutlined style={{ color: "red" }} />}
                    onClick={() => handleQuestionRemove(qIndex)}
                  />
                </div>
                <Form.Item
                  label={`Question's image`}
                  tooltip="Attach an image with the question provided"
                >
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    customRequest={({ file, onSuccess }) => {
                      handleQuestionImageUpload(file, qIndex).then(() =>
                        onSuccess("ok")
                      );
                    }}
                    showUploadList={false}
                  >
                    {question.questionImage ? (
                      <img
                        src={question.questionImage}
                        style={{ width: "100%", height: "100%" }}
                        alt={`Question ${qIndex + 1} Image`}
                      />
                    ) : (
                      "Upload an image"
                    )}
                  </Upload>
                </Form.Item>
                <Form.Item label=" Answer type">
                  <Select
                    defaultValue={question.questionType}
                    onChange={(value) =>
                      handleQuestionChange(qIndex, "questionType", value)
                    }
                    style={{ width: "100%" }}
                  >
                    <Option value="Text">Text</Option>
                    <Option value="Multiple Choice">Multiple Choice</Option>
                    <Option value="Upload File">Upload File</Option>
                    <Option value="Upload Video">Upload Video</Option>
                  </Select>
                </Form.Item>
                <div>
                  {question.questionType === "Multiple Choice" && (
                    <>
                      {(question.questionChoices ?? []).map(
                        (choice, cIndex) => (
                          <div
                            key={cIndex}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              columnGap: "8px",
                            }}
                          >
                            <Form.Item
                              label={`Choice ${cIndex + 1}`}
                              style={{ width: "70%", marginBottom: "0" }}
                            >
                              {choice.type === "text" ? (
                                <Input
                                  value={choice.value}
                                  onChange={(e) =>
                                    handleChoiceChange(
                                      qIndex,
                                      cIndex,
                                      "value",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                <Upload
                                  customRequest={({ file, onSuccess }) => {
                                    handleFileUpload(file, qIndex, cIndex).then(
                                      () => onSuccess("ok")
                                    );
                                  }}
                                  showUploadList={false}
                                >
                                  <Button icon={<UploadOutlined />}>
                                    Upload Image
                                  </Button>
                                </Upload>
                              )}
                            </Form.Item>
                            <Select
                              defaultValue={choice.type}
                              onChange={(value) =>
                                handleChoiceChange(
                                  qIndex,
                                  cIndex,
                                  "type",
                                  value
                                )
                              }
                              style={{ width: "20%", flex: "1 0 auto" }}
                            >
                              <Option value="text">Text</Option>
                              <Option value="image">Image</Option>
                            </Select>
                            <Button
                              icon={
                                <MinusCircleOutlined style={{ color: "red" }} />
                              }
                              onClick={() => handleChoiceRemove(qIndex, cIndex)}
                            ></Button>
                          </div>
                        )
                      )}
                      <Button
                        icon={<PlusOutlined />}
                        type="dashed"
                        onClick={() => handleChoiceAdd(qIndex)}
                        style={{ marginBottom: "10px" }}
                      >
                        Add Choice
                      </Button>
                      <br />
                      <p>Correct Answer:</p>
                      <Radio.Group
                        onChange={(e) =>
                          handleCorrectAnswerChange(qIndex, e.target.value)
                        }
                        value={question.questionCorrectAnswer}
                      >
                        {(question.questionChoices ?? []).map(
                          (choice, cIndex) => (
                            <div>
                              <Radio key={cIndex} value={choice.value}>
                                {choice.type === "text" ? (
                                  choice.value
                                ) : (
                                  <img
                                    src={choice.value}
                                    alt={`Choice ${cIndex + 1}`}
                                    style={{ width: "50px", height: "50px" }}
                                  />
                                )}
                                <br />
                              </Radio>
                            </div>
                          )
                        )}
                      </Radio.Group>
                    </>
                  )}
                </div>
              </div>
            ))}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            columnGap: "16px",
          }}
        >
          {/* <Button
            style={{
              width: "fit-content",
              alignSelf: "center",
              margin: "4px 0",
            }}
            onClick={showConfirm}
            type="primary"
            danger
          >
            Disable Form
          </Button> */}
          <Button
            type="primary"
            style={{
              width: "fit-content",
              alignSelf: "center",
              margin: "4px 0",
            }}
            ghost
            icon={<PlusOutlined />}
            onClick={() => handleQuestionAdd(formDetails.questions.length)}
          >
            Add Question
          </Button>
          <Button
            style={{ width: "fit-content", alignSelf: "center" }}
            type="primary"
            onClick={handleFormSubmit}
          >
            Submit Form
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default FormBuilderPage;
